import { render, staticRenderFns } from "./inspectScreenEasy.vue?vue&type=template&id=79916ada&scoped=true"
import script from "./inspectScreenEasy.vue?vue&type=script&lang=js"
export * from "./inspectScreenEasy.vue?vue&type=script&lang=js"
import style0 from "./inspectScreenEasy.vue?vue&type=style&index=0&id=79916ada&prod&lang=scss&scoped=true"
import style1 from "./inspectScreenEasy.vue?vue&type=style&index=1&id=79916ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79916ada",
  null
  
)

export default component.exports